import React from 'react'
import { Button, Text } from '../../../../../designSystem'
import { handleEventLog } from '../../../../../lib/utils'
import * as Styles from './styles'

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const DailyChapterBonus = ({
  publishDate,
  stepperData,
  onAddChapter,
  chapterId,
}) => {
  const isMobile = window.screen.width < 600
  const modifiedStepperData = [
    {
      chapter_number: 0,
      bonus_amount: 0,
      publish_status: true,
    },
    ...stepperData,
  ]
  const totalSteps = modifiedStepperData.length - 1
  const activeStep =
    modifiedStepperData?.filter((eachStep) => eachStep?.publish_status).length - 1
  const stepperWidth = `${(activeStep / totalSteps) * 100}%`

  function getStepperAmountTitle(chapterNumber) {
    if (activeStep === 1 && activeStep + 1 === chapterNumber) {
      return '2nd Chp Bonus'
    }

    if (activeStep === 2 && activeStep + 1 === chapterNumber) {
      return '3rd Chp Bonus'
    }
    return ''
  }

  if (activeStep < 3) {
    return (
      <Styles.Wrapper>
        <Styles.Heading>MORE CHAPTERS, MORE BONUS!</Styles.Heading>
        <Styles.BonusWrapper>
          <Styles.DateWrapper>
            <Styles.Line />

            <Styles.CurrentDate>{`${new Date().getDate()}-${
              months[new Date().getMonth()]
            }-${new Date().getFullYear()}`}</Styles.CurrentDate>
            <Styles.Line />
          </Styles.DateWrapper>
          <Styles.ProgressWrapper>
            <Styles.DailyChapterText>Daily Chapters</Styles.DailyChapterText>
            <Styles.Steps>
              {modifiedStepperData.map((each) => (
                <Styles.EachStep key={each.chapter_number}>
                  <Styles.StepWrapper
                    isPublished={each.publish_status}
                    isVisible={each.chapter_number !== 0}
                  >
                    {each.chapter_number}
                  </Styles.StepWrapper>
                  {each.chapter_number !== 0 && (
                    <Styles.ChapterText>Chp</Styles.ChapterText>
                  )}
                </Styles.EachStep>
              ))}
            </Styles.Steps>
          </Styles.ProgressWrapper>
          <Styles.LineProgress
            stepperWidth={stepperWidth}
            allStepsCompleted={activeStep / totalSteps === 1}
          />
          <Styles.Steps>
            {modifiedStepperData.map((each) => (
              <Styles.EachProgressStep
                key={each.chapter_number}
                isVisible={each.chapter_number !== 0}
                currentChapter={each.chapter_number}
                activeStep={activeStep}
              >
                <Styles.StepLine
                  isActive={activeStep === each.chapter_number}
                  nextActive={activeStep + 1 === each.chapter_number}
                >
                  <Styles.GradientLine
                    isActive={activeStep === each.chapter_number}
                  />
                  <Styles.Circle
                    isActive={activeStep === each.chapter_number}
                  />
                  <Styles.ChapterInfoWrapper
                    nextActive={activeStep + 1 === each.chapter_number}
                  >
                    <Styles.NextChapterText>
                      {getStepperAmountTitle(each.chapter_number)}
                    </Styles.NextChapterText>
                    <Styles.ProgressStepWrapper
                      isPublished={each.publish_status}
                      isVisible={each.chapter_number !== 0}
                      nextActive={activeStep + 1 === each.chapter_number}
                    >
                      {`+₹${each.bonus_amount}`}
                    </Styles.ProgressStepWrapper>
                  </Styles.ChapterInfoWrapper>
                </Styles.StepLine>
              </Styles.EachProgressStep>
            ))}
          </Styles.Steps>
        </Styles.BonusWrapper>
      </Styles.Wrapper>
    )
  }

  return (
    <Styles.GirlBackBox>
      {!isMobile && (
        <Text variant="headingPrimary" fontSize={[20, 24]} mt={24}>
          Don’t keep your fans waiting!
        </Text>
      )}
      {isMobile && (
        <Styles.MobileGirlBackBox>
          <img src="/images/girl-writer-mobile.svg" alt="" />
          <Styles.MobileGirlBackBoxTxt>
            Don’t keep your fans waiting!
          </Styles.MobileGirlBackBoxTxt>
        </Styles.MobileGirlBackBox>
      )}
      <Button
        mt={24}
        onClick={() => {
          onAddChapter()
          handleEventLog('post_publish_variant_b', 'button_click', {
            route: window.location.pathname + window.location.search,
            entity_id: chapterId,
            entity_type: 'chapter',
            button: 'Write Your Next Chapter Now!',
          })
        }}
        fontSize={16}
      >
        Write Your Next Chapter Now!
      </Button>
    </Styles.GirlBackBox>
  )
}

export default DailyChapterBonus
